import React from 'react';
import ResourceModule from '../components/ResourceModule';

const money = { type: 'currency' };

export const Deals = () => (
  <ResourceModule
    title="Deals" endpoint="deals" createLabel="Novo Deal"
    columns={[
      { key: 'cliente', label: 'CLIENTE', strong: true },
      { key: 'veiculo', label: 'VEÍCULO', hideMobile: true },
      { key: 'vendedor', label: 'VENDEDOR', hideMobile: true },
      { key: 'valorVeiculo', label: 'VALOR', type: 'currency', right: true },
      { key: 'grossProfit', label: 'GROSS', type: 'currency', right: true, hideMobile: true },
    ]}
    statusKey="status" statusOptions={['Working', 'Manager Review', 'Approved', 'Signed', 'Funded', 'Delivered', 'Lost']}
    fields={[
      { key: 'cliente', label: 'Cliente', required: true, span2: true },
      { key: 'veiculo', label: 'Veículo', span2: true },
      { key: 'vendedor', label: 'Vendedor' },
      { key: 'status', label: 'Status', type: 'select', options: ['Working', 'Manager Review', 'Approved', 'Signed', 'Funded', 'Delivered', 'Lost'] },
      { key: 'valorVeiculo', label: 'Valor do veículo', ...money },
      { key: 'desconto', label: 'Desconto', ...money },
      { key: 'entrada', label: 'Entrada', ...money },
      { key: 'grossProfit', label: 'Gross Profit', ...money },
    ]}
  />
);

export const TradeIn = () => (
  <ResourceModule
    title="Trade-In" endpoint="trade_ins" createLabel="Nova Avaliação"
    columns={[
      { key: 'cliente', label: 'CLIENTE', strong: true },
      { key: 'veiculo', label: 'VEÍCULO', hideMobile: true },
      { key: 'km', label: 'KM', hideMobile: true },
      { key: 'appraisedValue', label: 'AVALIADO', type: 'currency', right: true },
    ]}
    statusKey="disposition" statusOptions={['Keep for Inventory', 'Wholesale', 'Auction']}
    fields={[
      { key: 'cliente', label: 'Cliente', required: true, span2: true },
      { key: 'veiculo', label: 'Veículo (Ano/Marca/Modelo)', span2: true },
      { key: 'vin', label: 'VIN' }, { key: 'km', label: 'Mileage', type: 'number' },
      { key: 'customerAsking', label: 'Valor pedido', ...money }, { key: 'payoff', label: 'Payoff', ...money },
      { key: 'appraisedValue', label: 'Valor avaliado', ...money },
      { key: 'disposition', label: 'Destino', type: 'select', options: ['Keep for Inventory', 'Wholesale', 'Auction'] },
    ]}
  />
);

export const Finance = () => (
  <ResourceModule
    title="Finance / F&I" endpoint="finance" createLabel="Nova Aplicação"
    columns={[
      { key: 'cliente', label: 'CLIENTE', strong: true },
      { key: 'lender', label: 'BANCO', hideMobile: true },
      { key: 'amountFinanced', label: 'FINANCIADO', type: 'currency', right: true },
      { key: 'apr', label: 'APR %', right: true, hideMobile: true },
      { key: 'term', label: 'PRAZO', right: true, hideMobile: true },
    ]}
    statusKey="status" statusOptions={['Application', 'Submitted', 'Approved', 'Stips Required', 'Contracted', 'Funded', 'Declined']}
    fields={[
      { key: 'cliente', label: 'Cliente', required: true, span2: true },
      { key: 'lender', label: 'Banco/Lender' }, { key: 'downPayment', label: 'Entrada', ...money },
      { key: 'amountFinanced', label: 'Valor financiado', ...money }, { key: 'apr', label: 'APR (%)', type: 'number' },
      { key: 'term', label: 'Prazo (meses)', type: 'number' }, { key: 'payment', label: 'Parcela', ...money },
      { key: 'status', label: 'Status', type: 'select', options: ['Application', 'Submitted', 'Approved', 'Stips Required', 'Contracted', 'Funded', 'Declined'] },
    ]}
  />
);

export const Recon = () => (
  <ResourceModule
    title="Recon" endpoint="recon_orders" createLabel="Novo Item Recon"
    columns={[
      { key: 'veiculo', label: 'VEÍCULO', strong: true },
      { key: 'categoria', label: 'CATEGORIA', type: 'badge' },
      { key: 'problema', label: 'PROBLEMA', hideMobile: true },
      { key: 'prioridade', label: 'PRIORIDADE', type: 'badge', hideMobile: true },
      { key: 'custoEstimado', label: 'ESTIMADO', type: 'currency', right: true },
    ]}
    statusKey="status" statusOptions={['Pending Inspection', 'Waiting Approval', 'Approved', 'Waiting Parts', 'In Progress', 'Quality Control', 'Completed']}
    fields={[
      { key: 'veiculo', label: 'Veículo', required: true, span2: true },
      { key: 'categoria', label: 'Categoria', type: 'select', options: ['Mechanical', 'Safety', 'Body', 'Interior', 'Detail', 'Tires', 'Brakes', 'Electrical', 'Fluids', 'Keys'] },
      { key: 'prioridade', label: 'Prioridade', type: 'select', options: ['Baixa', 'Média', 'Alta'] },
      { key: 'problema', label: 'Problema', span2: true },
      { key: 'custoEstimado', label: 'Custo estimado', ...money }, { key: 'responsavel', label: 'Responsável/Vendor' },
      { key: 'status', label: 'Status', type: 'select', options: ['Pending Inspection', 'Waiting Approval', 'Approved', 'Waiting Parts', 'In Progress', 'Quality Control', 'Completed'] },
    ]}
  />
);

export const Service = () => (
  <ResourceModule
    title="Service" endpoint="repair_orders" createLabel="Novo RO"
    columns={[
      { key: 'id', label: 'RO', strong: true },
      { key: 'cliente', label: 'CLIENTE' },
      { key: 'veiculo', label: 'VEÍCULO', hideMobile: true },
      { key: 'vin', label: 'VIN', hideMobile: true },
      { key: 'tipo', label: 'TIPO', type: 'badge', hideMobile: true },
      { key: 'tecnico', label: 'TÉCNICO', hideMobile: true },
      { key: 'estimativa', label: 'ESTIMATIVA', type: 'currency', right: true },
    ]}
    statusKey="status" statusOptions={['Checked In', 'Diagnosis', 'Estimate', 'Waiting Approval', 'Approved', 'Waiting Parts', 'Repair In Progress', 'Quality Control', 'Ready', 'Delivered', 'Closed']}
    fields={[
      { key: 'cliente', label: 'Cliente', span2: true }, { key: 'veiculo', label: 'Veículo', span2: true, required: true },
      { key: 'vin', label: 'VIN (17 caracteres)', span2: true },
      { key: 'km', label: 'Mileage', type: 'number' }, { key: 'tipo', label: 'Tipo', type: 'select', options: ['Customer RO', 'Internal RO'] },
      { key: 'reclamacao', label: 'Reclamação', span2: true }, { key: 'tecnico', label: 'Técnico' }, { key: 'advisor', label: 'Service Advisor' },
      { key: 'estimativa', label: 'Estimativa', ...money },
      { key: 'status', label: 'Status', type: 'select', options: ['Checked In', 'Diagnosis', 'Estimate', 'Waiting Approval', 'Approved', 'Waiting Parts', 'Repair In Progress', 'Quality Control', 'Ready', 'Delivered', 'Closed'] },
    ]}
  />
);

export const PostSale = () => (
  <ResourceModule
    title="Post-Sale" endpoint="post_sale_cases" createLabel="Novo Caso"
    columns={[
      { key: 'cliente', label: 'CLIENTE', strong: true },
      { key: 'veiculo', label: 'VEÍCULO', hideMobile: true },
      { key: 'tipo', label: 'TIPO', type: 'badge' },
      { key: 'prioridade', label: 'PRIORIDADE', type: 'badge', hideMobile: true },
      { key: 'responsavel', label: 'RESPONSÁVEL', hideMobile: true },
    ]}
    statusKey="status" statusOptions={['New', 'Assigned', 'Customer Contacted', 'Appointment Scheduled', 'Waiting Customer', 'Service', 'Waiting Parts', 'Resolved', 'Closed']}
    fields={[
      { key: 'cliente', label: 'Cliente', required: true, span2: true }, { key: 'veiculo', label: 'Veículo', span2: true },
      { key: 'tipo', label: 'Tipo', type: 'select', options: ['We Owe / Due Bill', 'Repair Promised', 'Customer Complaint', 'Registration', 'Plates', 'Title', 'Second Key', 'Warranty', 'Other'] },
      { key: 'prioridade', label: 'Prioridade', type: 'select', options: ['Baixa', 'Média', 'Alta'] },
      { key: 'reclamacao', label: 'Descrição', span2: true }, { key: 'responsavel', label: 'Responsável' },
      { key: 'status', label: 'Status', type: 'select', options: ['New', 'Assigned', 'Customer Contacted', 'Appointment Scheduled', 'Waiting Customer', 'Service', 'Waiting Parts', 'Resolved', 'Closed'] },
    ]}
  />
);

export const Tasks = () => (
  <ResourceModule
    title="Tasks" endpoint="tasks" createLabel="Nova Tarefa"
    columns={[
      { key: 'titulo', label: 'TAREFA', strong: true },
      { key: 'responsavel', label: 'RESPONSÁVEL', hideMobile: true },
      { key: 'prioridade', label: 'PRIORIDADE', type: 'badge', hideMobile: true },
      { key: 'vencimento', label: 'VENCIMENTO', hideMobile: true },
    ]}
    statusKey="status" statusOptions={['Open', 'In Progress', 'Waiting', 'Completed', 'Cancelled']}
    fields={[
      { key: 'titulo', label: 'Título', required: true, span2: true },
      { key: 'responsavel', label: 'Responsável' }, { key: 'prioridade', label: 'Prioridade', type: 'select', options: ['Baixa', 'Média', 'Alta'] },
      { key: 'vencimento', label: 'Vencimento', type: 'date' },
      { key: 'status', label: 'Status', type: 'select', options: ['Open', 'In Progress', 'Waiting', 'Completed', 'Cancelled'] },
      { key: 'descricao', label: 'Descrição', type: 'textarea', span2: true },
    ]}
  />
);

export const Documents = () => (
  <ResourceModule
    title="Documents" endpoint="documents" createLabel="Novo Documento"
    columns={[
      { key: 'nome', label: 'DOCUMENTO', strong: true },
      { key: 'categoria', label: 'CATEGORIA', type: 'badge' },
      { key: 'relacionado', label: 'RELACIONADO A', hideMobile: true },
      { key: 'createdBy', label: 'ENVIADO POR', hideMobile: true },
    ]}
    fields={[
      { key: 'nome', label: 'Nome do documento', required: true, span2: true },
      { key: 'categoria', label: 'Categoria', type: 'select', options: ['Customer', 'Vehicle', 'Deal', 'Post-Sale', 'Service'] },
      { key: 'relacionado', label: 'Relacionado a (cliente/veículo)', span2: true },
    ]}
  />
);
